import React from 'react';
import styled from 'styled-components';

import { Calendar, Typography } from 'antd';
import CalendarCell from './CalendarCell';
import dayjs from 'utils/dayjs';
import { useSelector } from 'react-redux';
import session from 'containers/App/session';
import { FEATURES } from 'utils/permissions';
import { RECOMMENDATION_VERSION } from 'right-revenue-microservice-sdk/lib/constants';

const CalendarCard = styled.div`
    width: 300px;
    border: 1px solid #f0f0f0;
    border-radius: 2px;
    margin-left: 3px;
    margin-right: 3px;
`;

const RecommendationsCalendar = ({ filters, data = [] }) => {
    const authorisedFeatures = useSelector(session.selectors.selectAccessibleFeatures);
    const currentMonth = dayjs(filters.startDate).startOf('month');
    const endMonth = dayjs(filters.endDate).endOf('month');
    const numMonths = Math.ceil(endMonth.diff(currentMonth, 'months', true));
    /**
     * Disable all dates. This is because if not disabled, a cell will trigger a
     * change in date when clicked and this behaviour cannot be disabled (internal
     * current date tracking in Antd's calendar)
     */
    const shouldDisableDate = () => true;
    // Do not show any header, including default Antd header
    // eslint-disable-next-line react/prop-types
    const headerRenderer = ({ value }) => {
        const current = value.clone();
        return (
            <div style={{ paddingTop: 0, textAlign: 'center' }}>
                <Typography.Title level={5}>{current.format('MMMM')}</Typography.Title>
            </div>
        );
    };

    const dateCellRenderer = (val) => {
        const date = dayjs(val.$d);
        const stayDate = date.format('YYYY-MM-DD');
        let recs = data || [];
        if (!authorisedFeatures.includes(FEATURES.viewAERecs)) {
            recs = data.filter(({ version }) => version !== RECOMMENDATION_VERSION.ANALYTICS_ENGINES);
        }
        const recommendation = recs.find((row) => row.stayDate === stayDate);
        const hasRecommendation =
            date.isSameOrAfter(dayjs(), 'day') &&
            recommendation !== undefined &&
            recommendation.recommendationsCount > 0;
        const outsideRange = date.isBefore(dayjs(filters.startDate)) || date.isAfter(dayjs(filters.endDate));
        const priority = recommendation?.priority || 0;

        return (
            <CalendarCell
                date={stayDate}
                hasRecommendation={hasRecommendation}
                outsideRange={outsideRange}
                priority={priority}
            />
        );
    };

    return [...Array(numMonths).keys()].map((key) => (
        <CalendarCard key={key}>
            <Calendar
                mode="month"
                headerRender={headerRenderer}
                fullCellRender={dateCellRenderer}
                value={currentMonth.clone().add(key, 'month')}
                disabledDate={shouldDisableDate}
                fullscreen={false}
            />
        </CalendarCard>
    ));
};

export default RecommendationsCalendar;
